function createProxy(target, handler) {
  if (process.env.NODE_ENV === "development") {
    if (typeof target !== "object" || !target) {
      console.warn(
        "Invalid object given for proxy:",
        target,
        `
  
  This can be due to a missing theme or configuration given to Tamagui.`,
        new Error().stack
      );
    }
  }
  return new Proxy(target || {}, handler);
}
export {
  createProxy
};
//# sourceMappingURL=createProxy.js.map
